import get from "lodash/get"
import axios from "axios"
import {
  GET_CONTACT_BACK_CASES_PENDING,
  GET_CONTACT_BACK_CASES_FULFILLED,
  GET_CONTACT_BACK_CASES_FAILED,
} from "constants-lib/actionTypes"
import URITemplate from "urijs/src/URITemplate"
import { urls } from "utils-lib/builds"
import { generateUniqueID } from "utils-lib/requests"

export const pendingAC = () => ({
  type: GET_CONTACT_BACK_CASES_PENDING,
})

export const failedAC = () => ({
  type: GET_CONTACT_BACK_CASES_FAILED,
})

export const fulfilledAC = (data) => ({
  type: GET_CONTACT_BACK_CASES_FULFILLED,
  payload: data,
})

/**
 * Fetches contact back attributes based on the provided parameters.
 * @param {Object} params - The parameters for the function.
 * @param {string} params.email - The email of the contact.
 * @param {string} params.fromDate - The date from which cases should be queried (usually backdated 6 months).
 * @param {string} params.toDate - The date to which cases should be queried (usually today).
 * @returns {function} A function that takes the Redux dispatch function as an argument.
 */
export const getContactBackCases =
  ({ fromDate, toDate }) =>
  (dispatch, getState) => {
    const state = getState()
    const api = `CONTACT_BACK_GET_CASE`
    const template = URITemplate(urls.url[api])
    const url = template.expand({
      email: get(state, `userAccount.userDetails.login`, ``),
      from: fromDate || ``,
      to: toDate || ``,
    })

    dispatch(pendingAC())

    const config = {
      headers: {
        "Request-Tracking-Id": generateUniqueID(),
        "Source-App": `WM_UI`,
        "Content-Type": `application/json`,
      },
    }

    return axios
      .get(url, config)
      .then((response) => {
        const redirectUrl = urls.salesforce.casePortal.url
        response.data.redirect = redirectUrl

        dispatch(fulfilledAC(response.data))
        return response.data
      })
      .catch((error) => {
        dispatch(failedAC((error, `response.status`, ``)))
        return error
      })
  }
